<!--Stas 2026-->
<template>
  <Modal @backgroundClose="$emit('close')">
    <div class="modal">
      <div class="modalwrap2-topline">
        <div class="topline-minizone"></div>
        <Breadcrumps
          :data="[{ title: $t('FertilizerAddProductModal:Title') }]"
        />
        <div class="topline-minizone">
          <Button
            size="s-standart"
            color="accentlightlines"
            icon="x"
            :is-loading="false"
            :loading-left="true"
            @click="$emit('close')"
          />
        </div>
      </div>

      <div class="modalwrap2-content">
        <div
          class="modalwrap3-inputs margintop--standart marginbottom--standart"
        >
          <DropdownPlusSelect
            :label="$t('FertilizerAddProductModal:ProductSelect.Placeholder')"
            :placeholder="$t('FertilizerAddProductModal:ProductSelect.Label')"
            size="long"
            :autofocus="true"
            v-model="selectedItem"
            :options="selectableProducts"
            dd-max-elements="6"
          />
        </div>

        <div class="modalwrap3-buttons">
          <Button
            :text="$t('FertilizerAddProductModal:ButtonCancel')"
            size="wide"
            color="graylines"
            icon="cancel"
            :is-loading="false"
            :loading-left="true"
            @click="$emit('close')"
          />
          <Button
            :text="$t('FertilizerAddProductModal:ButtonSave')"
            size="wide"
            color="accent"
            icon="save"
            :is-loading="false"
            :loading-left="true"
            :disabled="!canSave"
            @click="save"
          />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/pages/Modal';
import Breadcrumps from '@/components/views/Breadcrumps';
import Button from '@/components/views/Button';
import DropdownPlusSelect from '@/components/views/wrappers/DropdownPlusSelect';

export default {
  name: 'DefenseAddProductModal',
  components: {
    Modal,
    Breadcrumps,
    Button,
    DropdownPlusSelect,
  },
  props: {
    productsList: { type: Array, required: true },
    alreadyAdded: { type: Array, required: true },
  },
  data() {
    return {
      selectedItem: null,
    };
  },
  computed: {
    selectableProducts() {
      return this.productsList.map((p) => ({
        ...p,
        value: p.id,
        text: p.name,
        label: p.name,
        exists: this.alreadyAdded.includes(p.id),
      }));
    },
    canSave() {
      return this.selectedItem !== null && !this.selectedItem.exists;
    },
  },
  methods: {
    save() {
      this.$emit('save', this.selectedItem.value);
      this.$emit('close');
    },
  },
};
</script>
